module.exports = __webpack_public_path__ + "img/fantasy-art-masthead.10660454.jpg";